import { useState } from "react";
import useActiveItem from "hooks/useActiveItem";
import SellPopupConfirm from "./SellPopupConfirm";
import SellPopupSuccess from "./SellPopupSuccess";
import SellPopupError from "./SellPopupError";
import ModalWindow from "components/ModalWindow";

const SellPopup = ({close}) => {

  const {activeItem} = useActiveItem();
  const [step, setStep] = useState('confirm');

  const nextStep = (error) => {
    if (error) setStep('error')
    else if (!error && step === 'confirm') setStep('success')
  }
  return (
    <ModalWindow close={close}>
      {step === 'confirm' && <SellPopupConfirm activeItem={activeItem} closePopup={close} nextStep={nextStep} />}
      {step === 'success' && <SellPopupSuccess closePopup={close} />}
      {step === 'error' && <SellPopupError closePopup={close} />}
    </ModalWindow>
  )
}

export default SellPopup;
